import ConfirmationModalNotificationComponent from "./ConfirmationModalNotificationComponent";

export default ConfirmationModalNotificationComponent